module.exports = __webpack_public_path__ + "static/media/1v.70184048.jpg";